<template>
  <div class="ccckDetail">
    <div
      style="
            position: absolute;
             right: 50px;
             top: 110px;
           font-size: 40px;
          color: rgb(96, 98, 102);
          cursor: pointer;
          "
      @click="closePage"
    >
      <i class="el-icon-circle-close" />
    </div>
    <div class="title">
      <div class="title_left">进口核查</div>
    </div>
    <div v-loading="loading" class="mainContent">
      <div id="pdfMain" style="width: 1000px; margin: 0 auto">
        <!-- 标题 -->
        <div class="mainContent_title">
          进 口 易 制 毒 化 学 品 核 查 通 知 单
        </div>
        <div class="mainContent_1">核查表号：{{ formData.hcNo }}</div>
        <div class="mainContent_2">
          <div class="mainContent_2_left" style="text-indent: 2em">
            签发机关：{{ formData.jfJgmc }}
          </div>
          <div class="mainContent_2_right">
            签发日期：{{ formData.jfDate }}
          </div>
          <!-- <div class="mainContent_2_right">签发日期： 2021 年 12 月 9 日</div> -->
        </div>
        <el-form
          ref="formData"
          :model="formData"
          class="formData"
          inline-message
          :hide-required-asterisk="true"
          :show-message="false"
          :status-icon="showValid"
          disabled
        >
          <div class="mainContent_3">
            <table align="center" width="100%">
              <!-- <table
              style="border-collapse: collapse"
              border="1"
              bgcolor="#f2f2f2 "
              align="center"
              width="100%"
            > -->
              <tr align="center">
                <th colspan="2">商务部申请表号</th>
                <td colspan="2">{{ formData.appno }}</td>
                <td>核查截止日期</td>
                <td colspan="2">{{  formData.hcJzDate }}</td>
              </tr>

              <!-- 化学品 -->
              <tr align="center">
                <th rowspan="3" valign="left" width="40px">化学品</th>
                <th>序号</th>
                <th colspan="2">品名</th>
                <th>数量</th>
                <th colspan="2">计量单位</th>
              </tr>
              <tr align="center">
                <td>1</td>
                <td colspan="2">{{ formData.cdCNa }}</td>
                <td>{{ formData.tQty }}</td>
                <td colspan="2">{{ formData.cdUnit }}</td>
              </tr>
              <tr align="center">
                <td>2</td>
                <td colspan="2" />
                <td />
                <td colspan="2" />
              </tr>

              <!-- 贸易合同号 -->
              <tr align="center">
                <th
                  width="1px

            "
                  colspan="2"
                >
                  贸易合同号
                </th>
                <td colspan="5">{{ formData.contrNo }}</td>
              </tr>

              <!-- 进口单位 -->
              <tr align="center">
                <th rowspan="3" valign="left" width="40px">进口单位</th>
                <th width=" 20%">单位名称</th>
                <td colspan="5">{{ formData.consigneeCn }}</td>
              </tr>
              <tr align="center">
                <td width=" 20%">单位地址</td>
                <td colspan="5">{{ formData.consigneeAddrCn }}</td>
              </tr>
              <tr align="center">
                <td width=" 20%">法定代表人</td>
                <td colspan="2">{{ formData.consigneeLegalName }}</td>
                <th>联系电话</th>
                <td colspan="2">{{ formData.consigneeTel }}</td>
              </tr>

              <!-- 出口单位 -->
              <tr align="center">
                <th rowspan="4" valign="left" width="40px">出口单位</th>
                <th width=" 20%">单位名称</th>
                <td colspan="5">{{ formData.exporterCn }}</td>
              </tr>
              <tr align="center">
                <td width=" 20%">所在国家</td>
                <td colspan="2">{{ formData.cnyCNa }}</td>
                <th>出口港</th>
                <td colspan="2">{{ formData.exporterPort }}</td>
              </tr>
              <tr align="center">
                <td width=" 20%;">单位地址</td>
                <td colspan="5">{{ formData.exporterAdd }}</td>
              </tr>
              <tr align="center">
                <td width=" 20%">联系人</td>
                <td width="12%" />
                <!-- <td>乄乄乄</td> -->
                <th width="12%">联系电话</th>
                <td>{{ formData.exporterTel }}</td>
                <th>运输方式</th>
                <td>{{ formData.transCna }}</td>
              </tr>
              <!-- 最终用户 -->
              <tr align="center">
                <th colspan="2">最终用户</th>
                <td colspan="5">{{ formData.enduserCn }}</td>
              </tr>
              <!-- 备注 -->
              <tr align="center">
                <th colspan="2">备注</th>
                <td colspan="5">{{ formData.spec }}</td>
              </tr>

              <!-- 核查内容 -->
              <tr align="center" bgcolor="#fff ">
                <th rowspan="6" valign="left" width="40px">
                  <span>核查内容</span>
                </th>
                <th width="20%">序号</th>
                <th colspan="2">核查项目</th>
                <th colspan="3">核查结果</th>
              </tr>
              <tr align="center" bgcolor="#fff ">
                <td>1</td>
                <th colspan="2" style="padding-left: 10px">资质情况</th>
                <td colspan="3">
                  <!-- <input type="text" /> -->
                  <el-form-item
                    label=""
                    prop="zzqkHc"
                    :rules="[{ required: true }]"
                  >
                    <el-input
                      readonly
                      v-model="formData.zzqkHc"
                      :maxlength="255"
                    />
                  </el-form-item>
                </td>
              </tr>
              <tr align="center" bgcolor="#fff ">
                <td>2</td>
                <th colspan="2" style="padding-left: 10px">用途</th>
                <td colspan="3" align="left" class="yongtu">
                  <el-form-item
                    label=""
                    prop="ytLx"
                    :show-message="true"
                    :rules="[{ required: true }]"
                  >
                    <el-checkbox-group v-model="yongtu" class="jkhccheckbox">
                      <el-checkbox label="1">自用</el-checkbox>
                      <el-checkbox label="2">经销</el-checkbox>
                    </el-checkbox-group>
                    <i
                      v-if="showValid && !(yongtu && yongtu.length > 0)"
                      class="el-icon-circle-close erroricon"
                    />
                  </el-form-item>

                  <!-- 可输入 -->
                  <div class="hcnr_yongtu">
                    <el-form-item
                      class="default"
                      label="最终用户:"
                      prop="ytZzyh1"
                      :rules="[
                        { required: yongtu && yongtu.indexOf('2') !== -1 },
                      ]"
                    >
                      <el-input
                        readonly
                        v-model="formData.ytZzyh1"
                        :maxlength="255"
                      />
                    </el-form-item>
                    <el-form-item
                      class="default"
                      label="最终用户:"
                      prop="ytZzyh2"
                    >
                      <el-input
                        readonly
                        v-model="formData.ytZzyh2"
                        :maxlength="255"
                      />
                    </el-form-item>
                    <el-form-item
                      class="default"
                      label="最终用户:"
                      prop="ytZzyh3"
                    >
                      <el-input
                        readonly
                        v-model="formData.ytZzyh3"
                        :maxlength="255"
                      />
                    </el-form-item>
                  </div>
                </td>
              </tr>
              <tr align="center" bgcolor="#fff ">
                <td>3</td>
                <th colspan="2" style="padding-left: 10px">进口港</th>
                <td colspan="3">
                  <el-form-item
                    label=""
                    prop="jkgHc"
                    :rules="[{ required: true }]"
                  >
                    <el-input
                      readonly
                      v-model="formData.jkgHc"
                      :maxlength="255"
                    />
                  </el-form-item>
                </td>
              </tr>
              <tr align="center" bgcolor="#fff ">
                <td>4</td>
                <th colspan="2" style="padding-left: 10px">仓储地</th>
                <td colspan="3">
                  <el-form-item
                    label=""
                    prop="ccdHc"
                    :rules="[{ required: true }]"
                  >
                    <el-input
                      readonly
                      v-model="formData.ccdHc"
                      :maxlength="255"
                    />
                  </el-form-item>
                </td>
              </tr>
              <tr align="center" bgcolor="#fff ">
                <td>5</td>
                <th colspan="2" style="padding-left: 10px">
                  运输方式
                </th>
                <td colspan="3">
                  <el-form-item
                    label=""
                    prop="ysfsHc"
                    :rules="[{ required: true }]"
                  >
                    <el-input
                      readonly
                      v-model="formData.ysfsHc"
                      :maxlength="255"
                    />
                  </el-form-item>
                </td>
              </tr>

              <!-- 核查结论 -->
              <tr align="center" bgcolor="#fff ">
                <th rowspan="4" valign="left" width="40px">
                  <span>核查结论</span>
                </th>
                <td colspan="6" align="left" style="padding-left: 30px">
                  <el-form-item
                    label=""
                    prop="status"
                    :rules="[{ required: true }]"
                  >
                    <el-radio-group v-model="formData.status">
                      <el-radio label="22">核查通过</el-radio>
                      <el-radio label="24">核查不通过</el-radio>
                    </el-radio-group>
                    <i
                      v-if="showValid && !formData.status"
                      class="el-icon-circle-close erroricon"
                    />
                  </el-form-item>
                </td>
              </tr>
              <tr align="center" bgcolor="#fff ">
                <td>备注</td>

                <!--  align="left" -->
                <td colspan="5">
                  <el-form-item label="" prop="remark">
                    <el-input
                      readonly
                      v-model="formData.remark"
                      :maxlength="255"
                      class="left"
                    />
                  </el-form-item>
                </td>
              </tr>
              <tr align="center" bgcolor="#fff ">
                <td>核查人</td>
                <td colspan="2">
                  <el-form-item
                    label=""
                    prop="hcRen"
                    :rules="[{ required: true }]"
                  >
                    <el-input
                      readonly
                      v-model="formData.hcRen"
                      :maxlength="50"
                    />
                  </el-form-item>
                </td>
                <th>联系电话</th>
                <td colspan="2">
                  <el-form-item
                    label=""
                    prop="hcPhone"
                    :rules="[{ required: true }]"
                  >
                    <el-input
                      readonly
                      v-model="formData.hcPhone"
                      :maxlength="50"
                    />
                  </el-form-item>
                </td>
              </tr>
              <tr align="center" bgcolor="#fff ">
                <td>核查机关</td>
                <td colspan="2">{{ formData.hcJgmc }}</td>
                <th>核查日期</th>
                <td colspan="2">
                  <el-form-item
                    label=""
                    prop="hcTime"
                  >
                    <!-- <el-input
                      v-model="formData.hcTime"
                      placeholder=""
                    ></el-input> -->
                    <el-date-picker
                      readonly
                      v-model="formData.hcTime"
                      :clearable="false"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="yyyy-MM-dd"
                      type="date"
                    />
                  </el-form-item>
                </td>
              </tr>
            </table>
          </div>

          <div class="mainContent_4">
            <div class="mainContent_4_1">
              <el-form-item
                class="default"
                label="签发人："
                prop="qfRen"
                :rules="[{ required: true }]"
              >
                <el-input
                  v-model="formData.qfRen"
                  :maxlength="50"
                  readonly
                />
              </el-form-item>
            </div>
            <div class="mainContent_4_2">
              <el-form-item
                class="default"
                label="复核人："
                prop="fhRen"
                :rules="[{ required: true }]"
              >
                <el-input
                  v-model="formData.fhRen"
                  :maxlength="50"
                  readonly
                />
              </el-form-item>
            </div>
            <div class="mainContent_4_3">
              <el-form-item
                class="default"
                label="经办人："
                prop="jbRen"
                :rules="[{ required: true }]"
              >
                <el-input
                  v-model="formData.jbRen"
                  :maxlength="50"
                  readonly
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div style="    margin-left: 10%;
    width: 80%;
    text-align: center;
    margin-bottom: 20px;">
        <p style="font-size: 25px;text-align: left">附件图片</p>
        <el-table
          :data="downloadFiles"
          border
          style="width: 100%"
        >
          <el-table-column fixed label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="fileName"
            label="文件名"
          />
          <el-table-column
            prop="expctrlName"
            label="描述"
          />
          <el-table-column
            label="图片/pdf文件"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                round
                @click="getPicUrl(scope.row.ftpUrl)"
              >查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import {kfjkhcDetail} from "@/assets/js/system";
import {returnShowPic} from "@/assets/js/common";
export default {
  props: ['dataId'],
  data() {
    return {
      loading: false,
      hcDialogVisible: false,
      showValid: false,
      showBack: false,
      centerDialogVisible: false,
      downloadFj: false,
      downloadFiles: [],
      radio: '',
      yongtu: [],
      data: [],
      formData: {},
      submitForm: {
      },
      orgsData: [],
      hcnr_yongtuShow: true, // 核查内容  自用 / 营销 切换输入框

    }
  },
  mounted() {
    if (this.dataId) {
      this.loadData()
    } else {
      this.closePage()
      this.$message({
        type: 'warning',
        message: '数据不存在!'
      })
    }
  },
  methods: {
    async getPicUrl(url) {

      const interfaceUrl  = returnShowPic()+url; // 你的图片接口

      // 2. 使用 window.open() 打开新窗口
      // 第一个参数是 URL，第二个参数是窗口名称（可自定义）
      // 第三个参数是新窗口的配置项（可选，如尺寸、位置等）
      const newWindow = window.open(interfaceUrl,'_blank'); //正式环境可以正常使用，测试环境若注释掉后端的"response.setHeader("Content-Type", "image/*");"也能正常显示

      // 3. 检查窗口是否成功打开（防止被浏览器弹窗拦截）
      if (!newWindow) {
        alert('无法打开新窗口，可能被浏览器的弹窗拦截器阻止了。请允许弹出窗口后重试。');
      }
    },
    loadData() {
      kfjkhcDetail(this.dataId).then(res => {
        if (res.data.code === '000000') {
          this.formData = res.data.data
          this.downloadFiles =  res.data.data.fjxxs
        }
      })
    },
    closePage() {
      this.$parent.dataId = ''
      this.$parent.pupopShow = false
    }
  }
}
</script>
<style scoped lang="less">
.ccckDetail {
  //@y1213
  height: 100%;
  background-color: #eef1f9;
  padding-top: 15px;
  .title {
    background-color: white;
    //width: 98%;
    width: calc(100% - 40px);
    margin: 0px auto;
    height: 50px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title_left {
      padding-left: 5px;
      border-left: #2674e0 3px solid;
      color: #2674e0;
      font-weight: 700;
    }
  }
  .mainContent {
    background-color: #fff;
    width: calc(100% - 40px);
    margin: 0 auto;
    overflow-y: auto;
    height: calc(100% - 70px);
    padding: 50px 100px 100px;

    div {
      width: 100%;
      font-size: 20px;
    }

    .mainContent_title {
      width: 100%;
      text-align: center;
      font-size: 40px;
      font-weight: 700;
    }
    .mainContent_1 {
      float: right;
      text-align: left;
      margin: 30px 0;
      width: 300px;
    }

    .mainContent_2 {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .mainContent_2_left {
        width: auto;
      }
      .mainContent_2_right {
        text-align: left;
        width: 300px;
      }
    }

    .mainContent_3 {
      width: 100%;
      margin: 10px 0;
    }

    .mainContent_4 {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
      div {
        width: 100%;
      }

      .mainContent_4_2 {
        text-align: center;
      }
      .mainContent_4_3 {
        text-align: right;
      }
    }

    .mainContent_5 {
      width: 100%;
      // padding: 0 300px;
      margin-top: 40px;
      display: flex;
      justify-content: center;
      div {
        width: 200px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}

.yongtu {
  /deep/.el-radio {
    display: block;
    line-height: 30px;
  }

  padding-left: 15px;
  font-size: 16px;
}
::-webkit-scrollbar-track {
  border-radius: 8px;
  -webkit-box-shodow: inset 0 0 6px rgba(200, 200, 200, 0.3);
  background-color: #f5f5f5;
}
::-webkit-scrollbar {
  width: 4px;
  border-radius: 8px;
  background-color: #f5f5f5;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(1, rgb(100, 100, 100))
  );
}
/deep/.el-input.is-disabled .el-input__inner,
/deep/.el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff !important;
}
th,
tr,
td {
  height: 50px;
  font-weight: 400;

  input {
    width: 100%;
    height: 100%;
    border: 0;
    text-align: center;
    outline: none;
  }
}

/deep/ .el-radio__label {
  font-size: 16px;
  color: black;
}

/deep/.el-dialog__header {
  background-color: rgb(1, 0, 75);
  .header-title {
    color: #fff;
    text-align: left;
  }
}
.formData {
  /deep/.el-form-item {
    margin-bottom: 0px;
    display: flex;
    flex-direction: row;
    .el-form-item__content {
      width: 100%;
    }
  }
  /deep/.el-input__inner {
    width: 100%;
    height: 100%;
    border: 0;
    text-align: center;
    outline: none;
    color: black;
  }
  /deep/.is-disabled .el-input__inner {
    color: black !important;
  }
  .left {
    /deep/.el-input__inner {
      text-align: left;
    }
  }
  .default {
    height: 35px;
    /deep/.el-input__inner {
      border-bottom: 1px solid #999;
      width: 90%;
      border-radius: 0px;
    }
    /deep/.el-form-item__label {
      width: 140px;
      text-align: left;
      font-size: 20px;
      color: black;
      font-weight: 400;
    }
  }
  .jkhccheckbox {
    display: flex;
    flex-direction: column;
    /deep/.el-checkbox {
      font-size: 20px;
      line-height: 30px;
    }
    /deep/.el-checkbox__inner {
      width: 20px;
      height: 20px;
    }
    /deep/.el-checkbox__label {
      font-size: 18px;
      padding-left: 5px;
      color: black;
    }
    /deep/.el-checkbox__inner::after {
      height: 10px;
      left: 7px;
    }
  }
  .erroricon {
    right: 8px;
    top: 10px;
    position: absolute;
    color: #f56c6c;
    font-size: 20px;
  }
  /deep/.el-radio__input.is-disabled + span.el-radio__label {
    color: black;
  }
  /deep/.el-radio__input.is-disabled .el-radio__inner {
    background-color: #fff;
    border-color: #333;
  }
  /deep/.el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #fff;
    border-color: #333;
    cursor: not-allowed;
  }
  /deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #333;
  }
  /deep/.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
    background-color: #333;
  }
  /deep/.el-icon-circle-check {
    display: none !important;
  }
  /deep/.el-input__prefix .el-input__icon {
    display: none;
  }
}

.hcnr_yongtu {
  width: 100%;

  span {
    display: block;
    line-height: 30px;

    input {
      width: 60%;
      border-bottom: 1px solid #ccc;
    }
  }
}
table {
  border-collapse: collapse;
  border: 1px solid black;
  tr {
    border-left: 1px solid black;
    border-right: 1px solid black;
  }
  tr:last-child {
    border-bottom: 1px solid black;
  }
  tr {
    th,
    td {
      border-top: 1px solid black;
      border-left: 1px solid black;
    }
    th:first-child {
      //  border-top: 1px solid red;
      border-left: none;
    }
  }
  // tr:first-child {
  //   th,
  //   td {
  //     border-top: none;
  //     border-left: none;
  //   }
  // }
}
</style>
